import { resolveAfterMillis } from './util';

const DEFAULT_LOAD_TIMEOUT = 4242;

/**
 * Load the component, swallow any errors.
 *
 * TODO maybe retry
 * @typedef loadComponentOptions
 * @param {Function} loader the dynamic import() callback
 * @param {Number} timeoutInMillis max time to wait for the component to be loaded
 */
export const loadComponent = async ({
  loader,
  timeoutInMillis = DEFAULT_LOAD_TIMEOUT
}) => {
  try {
    const loadedComponentModule = await Promise.race([
      loader(),
      resolveAfterMillis(timeoutInMillis)
    ]);
    if (!loadedComponentModule) {
      // timeout
      return;
    }
    return loadedComponentModule.default;
  } catch (error) {
    // network error
  }
};
